import { defineStore } from 'pinia'
import type { Context, SnakeContext } from '@/types/global.interfaces'

const useContextStore = defineStore({
  id: 'context',

  state: (): Context => ({
    accountsToken: undefined,
    accountsShopToken: undefined,
    currency: 'EUR',
    isoCode: undefined,
    isoLang: undefined,
    prestaShopControllerClassName: undefined,
    recommendationFormat: 'modal',
    shopUrl: undefined,
    shopVersion: undefined,
    shopUuid: undefined,
    userId: undefined,
    adminToken: undefined,
    refreshUrl: undefined,
    accountsUserId: undefined,
    accountsShopId: undefined,
    addonsPassword: undefined,
    addonsUsername: undefined,
    isConnectedToAddonsPS17: undefined,
    mboVersion: undefined,
    upgradableModules: undefined,
    shopCreationDate: undefined,
    algoliaContext: {
      queryID: undefined,
      index: undefined,
    },
    isPse: false,
  }),

  actions: {
    setContext(context: SnakeContext) {
      this.accountsToken = context.accounts_token
      this.accountsShopToken = context.accounts_shop_token
      this.mboToken = context.mbo_token
      this.currency = context.currency
      this.isoCode = context.iso_code
      this.isoLang = context.iso_lang
      this.prestaShopControllerClassName =
        context.prestaShop_controller_class_name
      this.recommendationFormat =
        context.recommendation_format ?? this.recommendationFormat
      this.shopUrl = context.shop_url
      this.shopUuid = context.shop_uuid
      this.shopVersion = context.shop_version
      this.userId = context.user_id
      this.adminToken = context.admin_token
      this.refreshUrl = context.refresh_url
      this.accountsUserId = context.accounts_user_id
      this.accountsShopId = context.accounts_shop_id
      this.accountsToken = context.accounts_token
      this.addonsPassword = context.addonsPassword
      this.addonsUsername = context.addonsUsername
      this.isConnectedToAddonsPS17 = context.isConnectedToAddonsPS17
      this.mboVersion = context.mbo_version
      this.upgradableModules = context.upgradable_modules
      this.shopCreationDate = context.shop_creation_date
        ? new Date(context.shop_creation_date)
        : undefined
    },

    setAlgoliaContext(queryID?: string, index?: string) {
      this.algoliaContext = { queryID, index }
    },

    enablePsEntreprise() {
      this.isPse = true
    },

    deleteUpgradableModule(moduleName: string) {
      this.upgradableModules = this.upgradableModules?.filter(
        (module: string) => module !== moduleName,
      )
    },
  },
  getters: {
    isOnMboPage(): boolean {
      return (
        this.prestaShopControllerClassName === 'AdminPsMboModuleParent' ||
        this.prestaShopControllerClassName === 'AdminPsMboModule'
      )
    },

    isConnectedToAddons(): boolean {
      return (
        (this.addonsPassword != undefined &&
          this.addonsUsername != undefined) ||
        this.isConnectedToAddonsPS17 ||
        false
      )
    },

    isConnectedToAccount(): boolean {
      return this.accountsToken != undefined && this.accountsToken != ''
    },
  },
})

export default useContextStore
export type ContextStore = ReturnType<typeof useContextStore>
